import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaUpload } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/component_select_media/actions'

const { Search } = Input

class HeadBar extends Component {
    _handleAddClick = () => {
        this.props.setDefaultCurrentMedia()
        this.props.showModalCurrentMediaInfo()
    }

    render() {
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddClick()}
                    >
                        <FaUpload className="iconButton" />
                        Upload tài liệu
                    </Button>
                </div>
                <div>
                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => this.props.searchMedia()}
                        onChange={e =>
                            this.props.updateCurrentTextSearch(e.target.value)
                        }
                        value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.component_select_media.textSearch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showModalCurrentMediaInfo: () => {
            dispatch(mediaActions.action.showModalCurrentMediaInfo())
        },
        setDefaultCurrentMedia: () => {
            dispatch(mediaActions.action.setDefaultCurrentMedia())
        },
        updateCurrentTextSearch: textSearch => {
            dispatch(mediaActions.action.updateTextSearch(textSearch))
        },
        searchMedia: () => {
            dispatch(mediaActions.action.searchMedia())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
